@import "config";

.radio {
	@include flex(row, unset, center);
	margin-bottom: $spacing-stack-nano;
	input {
		margin-right: $spacing-inset-nano;
		width: 16px;
		height: 16px;
	}

	label {
		color: $color-dark-d1;
	}
	input[disabled] + label {
		color: $color-dark-d5;
	}
}
